module.exports = __webpack_public_path__ + "img/calendar-30.eb4afcca.svg";